<template>
  <div class="vanRecordCard">
    <van-steps
      direction="vertical"
      active-color="#ECECEC"
      inactive-color="#ECECEC"
    >
      <van-step v-for="(item, index) in recordList" :key="index">
        <template #active-icon>
          <img
            v-if="item.isComingCall != 2"
            src="../common/images/progress/firstCall.png"
            alt
            class="record_icon"
          />
          <img
            v-else
            src="../common/images/progress/visited.png"
            alt
            class="record_icon"
          />
        </template>
        <template #inactive-icon>
          <img
            v-if="item.isComingCall != 2"
            src="../common/images/progress/firstCall.png"
            alt
            class="record_icon"
          />
          <img
            v-else
            src="../common/images/progress/visited.png"
            alt
            class="record_icon"
          />
        </template>
        <div class="record_card_item">
          <div class="top">
            <div class="left">
              <div class="callTime">{{ item.connectTime }}</div>
              <div class="first" v-if="item.isComingCall === 3">首次去电</div>
              <div class="onFirst" v-else>
                {{ connectType(item.isComingCall) }}
              </div>
            </div>
            <div class="line"></div>
            <div class="right">
              <div class="tips">
                <span
                  v-show="!showNot(tag) && tag.propertyValue !== ''"
                  v-for="tag in item.tagContentChar"
                  :key="tag.propertyName"
                  :class="{
                    formats: tag.propertyName === '需求业态' ? true : false,
                    age: tag.propertyName === '需求面积' ? true : false,
                    type: tag.propertyName === '购房意向' ? true : false,
                  }"
                  >{{ tag.propertyValue }}</span
                >
              </div>
            </div>
          </div>
          <div class="center" v-if="showTips(item.tagContentChar)">
            <div
              v-for="(tip, index) in item.tagContentChar === null
                ? []
                : item.tagContentChar"
              :key="index"
              v-show="
                showNot(tip) &&
                  tip.propertyName !== '备注信息' &&
                  tip.propertyValue !== ''
              "
            >
              <van-tabs :value="tip.propertyValue" />
            </div>
          </div>

          <div v-if="item.remark">
            <Pop :remark="item.remark" />
          </div>
        </div>
      </van-step>
    </van-steps>
  </div>
</template>

<script>
import tabs from '@/components/tabs';
import { Step, Steps } from 'vant';
import Pop from './pop';
export default {
  data() {
    return {
      viewIndex: '',
      show: false,
      tipsList: [],
      arr: [],
    };
  },
  components: {
    'van-step': Step,
    'van-steps': Steps,

    Pop,
    'van-tabs': tabs,
  },
  props: {
    recordList: {
      type: Array,
      default: () => [],
    },
    lastIndex: {
      type: Number,
      default: 0,
    },
  },
  created() {},
  methods: {
    //联系方式
    connectType(v) {
      if (v === 0) {
        return '去电';
      } else if (v === 1) {
        return '来电';
      } else {
        return '到访';
      }
    },
    //
    showNot(v) {
      if (v.propertyName === '需求业态') {
        return false;
      } else if (v.propertyName === '需求面积') {
        return false;
      } else if (v.propertyName === '购房意向') {
        return false;
      } else if (v.propertyName === '客户最关注的方面（多选）') {
        this.arr = v.propertyValue.split(',');
        return true;
      } else {
        return true;
      }
    },
    //
    showTips(v) {
      let list = v;
      let arr = [];
      if (list) {
        list.forEach((item) => {
          arr.push(item.propertyName);
        });
        arr = arr.filter((item) => {
          if (item !== '需求业态') {
            return item;
          }
        });
        arr = arr.filter((item) => {
          if (item !== '需求面积') {
            return item;
          }
        });
        arr = arr.filter((item) => {
          if (item !== '购房意向') {
            return item;
          }
        });

        if (arr.length) {
          return true;
        } else {
          return false;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.vanRecordCard {
  .record_icon {
    width: 80px;
    height: 80px;
  }
  .record_card_item {
    min-height: 200px;
    width: 100%;
    color: #333333;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 12px 0px rgba(164, 164, 164, 0.4);
    border-radius: 12px;
    padding: 0 30px;
    box-sizing: border-box;
    .top {
      height: 100px;
      width: 100%;
      display: flex;
      align-items: center;
      .left {
        width: 184px;
        height: 100%;
        display: flex;
        font-size: 24px;
        flex-direction: column;
        justify-content: space-evenly;
        .callTime {
          color: #666666;
        }
      }
      .line {
        width: 2px;
        height: 40px;
        background: rgba(244, 245, 245, 1);
        border-radius: 1px;
      }
      .right {
        flex: 1;
        height: 100%;
        font-size: 28px;
        display: flex;
        align-items: center;
        .xunwen {
          width: 112px;
          height: 56px;
          line-height: 56px;
          text-align: center;
          color: #0d825a;
          margin: {
            left: 24px;
            right: 24px;
          }
          background: rgba(220, 237, 232, 1);
          border-radius: 0px 12px 12px 12px;
        }
        .youyixiang {
          width: 132px;
          height: 56px;
          line-height: 56px;
          text-align: center;
          color: #d79414;
          background: rgba(246, 238, 217, 1);
          border-radius: 0px 12px 12px 12px;
        }
      }
    }
    .center {
      padding: {
        top: 24px;
        bottom: 10px;
      }
      box-sizing: border-box;
      display: flex;
      align-content: center;
      justify-content: left;
      flex-wrap: wrap;
      border-top: 2px solid #f4f5f5;
      div {
        margin: {
          bottom: 5px;
          right: 6px;
        }
      }
    }
  }
  .tips {
    margin-left: 30px;
    display: inline-flex;

    width: 100%;
    span {
      font-size: 24px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      margin-left: 10px;
      height: 56px;
      &:nth-child(1) {
        margin-left: 0;
      }
    }
    .formats {
      width: 100px;

      background: #d8eee7;
      border-radius: 0px 12px 12px 12px;

      color: #007458;
    }
    .age {
      width: 140px;

      background: #f6eed9;
      border-radius: 0px 12px 12px 12px;
      color: #d79414;
    }
    .type {
      width: 60px;

      background: #dde9f5;
      border-radius: 0px 12px 12px 12px;

      color: #5386b8;
    }
  }
}
</style>
